<template>
  <el-card v-loading="loading" shadow="never">
    <slot slot="header"></slot>
    <ul>
      <li v-for="(row, index) in datalist" v-bind:key="index">
        <span class="index">{{ index + 1 }}</span>
        <span class="name">{{ row.name }}</span>
        <span class="value">{{ row.value }}</span>
      </li>
    </ul>
    <div ref="chartDom" />
  </el-card>
</template>

<script>
let echarts = require('echarts')
let elementResizeDetectorMaker = require("element-resize-detector")

export default {
  data () {
    return {
      loading: false,
      yunnan: require('@/assets/530000.json'), //地图json数据
      datalist: []
    }
  },
  props: {
    params: { type: Object }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      if (this.loading) { return }
      this.loading = true
      const that = this
      that.$apis.trend.region.sales(this.params).then(res => {
        that.datalist = res.items
        let max = Math.max.apply(Math, res.items.map(item => item.value))
        let min = Math.min.apply(Math, res.items.map(item => item.value))
        if (min == max) { min = 0 }
        let option = {
          tooltip: {
            show: true,
            formatter: '{b}<br/>{c}万'
          },
          visualMap: {
            show: false,
            min: min,
            max: max / 2,
            text: ['max', 'min'],
            realtime: false,
            calculable: true,
            inRange: {
              color: ['#FFFFFF', '#1ABC9C']
            }
          },
          series: [
            {
              type: 'map',
              map: 'yunnan',
              zoom: 1.2,
              data: res.items,
              label: {
                show: true
              }
            }
          ]
        }
        const dom = that.$refs['chartDom']
        if (dom) {
          echarts.registerMap('yunnan', this.yunnan, {})
          let chart = echarts.getInstanceByDom(dom)
          if (chart == null) {
            chart = echarts.init(dom)
            // 点击事件
            chart.on('click', function (p) {
              that.$router.push({ path: "detail", query: { ...that.params, region: p.name } })
            })
            //响应刷新
            elementResizeDetectorMaker().listenTo(dom, function () {
              chart.resize()
            })
          }
          chart.setOption(option)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }

}
</script>

<style lang="scss" scoped>
:deep(.el-card) {
  &__body {
    display: grid;
    grid-template-columns: minmax(250px, 1fr) 1fr;
  }
}

ul {
  background: #fff;
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(auto-fit, minmax(16px, 1fr));
  grid-gap: 15px 20px;
  li {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    .index {
      flex-shrink: 0;
      background-color: #ccc;
      color: #fff;
      width: 16px;
      height: 16px;
      line-height: 16px;
      margin-right: 10px;
      display: inline-block;
      text-align: center;
    }
    .name {
      flex: 1;
    }
    .value {
      margin-left: 10px;
      &::after {
        content: '万';
        font-size: 50%;
      }
    }
  }
  li:first-child {
    .index {
      background-color: #f00;
    }
  }
}
</style>